import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import type { App as VueApp } from 'vue';
import { initAnalytics, optIn, optOut } from './analytics';

export function setupConsent(app: VueApp): void {
  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false,
        readOnly: false,
      },
    },

    onFirstConsent: () => {
      if (CookieConsent.acceptedCategory('analytics')) {
        initAnalytics(app);
        optIn();
      }
    },

    onConsent: () => {
      if (CookieConsent.acceptedCategory('analytics')) {
        initAnalytics(app);
        optIn();
      }
    },

    onChange: ({ changedCategories }) => {
      if (changedCategories.includes('analytics')) {
        if (CookieConsent.acceptedCategory('analytics')) {
          initAnalytics(app);
          optIn();
        } else {
          optOut();
        }
      }
    },

    language: {
      default: 'pl',
      translations: {
        pl: {
          consentModal: {
            title: 'Używamy plików cookie',
            description:
              'Ta strona używa plików cookie w celach analitycznych, aby lepiej zrozumieć, jak korzystasz z symulatora. Możesz zaakceptować wszystkie lub tylko niezbędne pliki cookie.',
            acceptAllBtn: 'Akceptuję wszystkie',
            acceptNecessaryBtn: 'Tylko niezbędne',
            showPreferencesBtn: 'Ustawienia',
          },
          preferencesModal: {
            title: 'Ustawienia plików cookie',
            acceptAllBtn: 'Akceptuję wszystkie',
            acceptNecessaryBtn: 'Tylko niezbędne',
            savePreferencesBtn: 'Zapisz ustawienia',
            sections: [
              {
                title: 'Niezbędne pliki cookie',
                description:
                  'Te pliki cookie są wymagane do działania strony i nie mogą być wyłączone.',
              },
              {
                title: 'Analityka',
                description:
                  'Pliki cookie analityczne pomagają nam zrozumieć, w jaki sposób korzystasz z symulatora, abyśmy mogli go ulepszać.',
                linkedCategory: 'analytics',
              },
            ],
          },
        },
      },
    },
  });
}
